module.exports = __webpack_public_path__ + "img/E20w.994d7a89.png";